import { render, staticRenderFns } from "./AutomationLanding.vue?vue&type=template&id=95d1b56a&scoped=true&"
import script from "./AutomationLanding.vue?vue&type=script&lang=js&"
export * from "./AutomationLanding.vue?vue&type=script&lang=js&"
import style0 from "./AutomationLanding.vue?vue&type=style&index=0&id=95d1b56a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d1b56a",
  null
  
)

export default component.exports